export default __webpack_public_path__ + "static/media/ripple-svgrepo-com.42b057c8.svg";